export default __webpack_public_path__ + "static/media/promo-phone.95031bd3.png";